import { CURRENCY_SYMBOLS } from 'Constants/commons';
import { CurrencyLabel } from 'Modules/Currency';
import { bool, func, shape } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'semantic-ui-react';

const FeeEstimation = ({ isFollowUp, goToFeeEstimation, consultFee, consult }) => {
  const { id: currentDrId } = useSelector(state => state.webChat.doctor.data);

  const isMainDoctor = currentDrId === consult?.doctor?.id;
  if (!isMainDoctor) return null;

  const { fixedFee, totalPrice, currency = '' } = consultFee?.estimate || {};
  const currencyText = consult.status === 1 ? currency : consultFee?.data?.currency;
  let estimateFee = consult.status === 1 ? totalPrice : consultFee?.data?.totalPrice;
  if (fixedFee) {
    estimateFee = totalPrice;
  }
  if (isFollowUp) estimateFee = 0;
  return (
    <div onClick={goToFeeEstimation} className="fee">
      <div className="label">Fee Est.</div>
      <div>
        <span className="value">
          {CURRENCY_SYMBOLS[currencyText] || ''}{' '}
          <CurrencyLabel value={estimateFee <= 0 ? 0 : estimateFee} />
        </span>
        {!isFollowUp && <Icon name="angle right" />}
      </div>
    </div>
  );
};

FeeEstimation.propTypes = {
  isFollowUp: bool.isRequired,
  consult: shape({}).isRequired,
  consultFee: shape({}).isRequired,
  goToFeeEstimation: func.isRequired,
};

FeeEstimation.defaultProps = {};

export default FeeEstimation;
